import { useCallback, useEffect, useState } from 'react'

/**
 * Enrutado mínimo sobre la API de historial del navegador. Son cuatro pantallas
 * y así no hay que cargar una librería de rutas entera.
 */
export function useRuta() {
  const [ruta, setRuta] = useState(() => window.location.pathname)

  useEffect(() => {
    const alVolver = () => setRuta(window.location.pathname)
    window.addEventListener('popstate', alVolver)
    return () => window.removeEventListener('popstate', alVolver)
  }, [])

  const ir = useCallback((destino: string) => {
    if (destino === window.location.pathname) return
    window.history.pushState({}, '', destino)
    setRuta(destino)
  }, [])

  return { ruta, ir }
}

/** Devuelve el uuid si la ruta es la de una ficha. */
export function uuidDeFicha(ruta: string): string | null {
  const coincidencia = /^\/fichas\/([0-9a-f-]{36})$/.exec(ruta)
  return coincidencia?.[1] ?? null
}
